module.exports = __webpack_public_path__ + "img/desc-1.3.0b2dfccc.jpg";